module.exports = __webpack_public_path__ + "img/monthly-sales.46223d09.svg";